<template>
	<div>
		<a href="#/backoffice/signatures">← back</a>
		<h1>{{sigStat.organization}}</h1>
		<h2 v-if="isAdmin">Total documents signed:{{total}}</h2>
		<div class="table-responsive">
			<table class="table table-bordered table-hover">
				<thead>
				<tr>
					<th>date</th>
					<th>doc signed</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="rec in sigStatOrderByDateReverse">
					<td>{{rec.date}}</td>
					<td>{{rec.value}}</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import ApiService from "../../../libs/ApiService";
	import MeStore from "../../../store/MeStore";
	import _ from "lodash"


	export default {
		name: "SignaturesStatistics",
		data() {
			return {
				sigStat: {
					organization: ''
				},
				signDatesList: [],
				total: 0,
				isAdmin: false
			}
		},
		computed: {
			sigStatOrderByDateReverse() {
				return _.orderBy(this.signDatesList, 'date', 'desc');
			}
		},
		methods: {},
		async mounted() {
			this.isAdmin = MeStore.state.user.isAdmin;
			let uuid = this.$route.params.uuid;
			let res = await ApiService.get('/private/signatures/' + uuid);
			this.sigStat = res.data;
			if (res.data.statistics && res.data.statistics.files_singed) {
				//normalize
				for (let key in res.data.statistics.files_singed) {
					let record = {
						date: key,
						value: res.data.statistics.files_singed[key]
					};
					if (key == 'total') {
						this.total = record.value;
					} else {
						this.signDatesList.push(record);
					}
				}
			}
		}
	}
</script>

<style scoped>

</style>